const Routing = {
  dispoAssistent: 'dispo-assistent',
} as const;

export default Routing;
